import { StatusBar, HomeBar } from "./primitives";

const font = "'Inter', sans-serif";

function App({ name, color, badge, top, left, rot, children, w = 760 }) {
  return (
    <div style={{ position: "absolute", top, left, width: w, transform: `rotate(${rot}deg)`, background: "#fff", borderRadius: 34, boxShadow: "0 30px 60px -20px rgba(0,0,0,.35)", overflow: "hidden", fontFamily: font }}>
      <div style={{ display: "flex", alignItems: "center", gap: 18, padding: "26px 34px", background: color, color: "#fff", fontWeight: 700, fontSize: 30 }}>
        <span style={{ width: 44, height: 44, borderRadius: 12, background: "rgba(255,255,255,.35)" }} />
        {name}
        {badge && <span style={{ marginLeft: "auto", background: "#E5484D", borderRadius: 999, padding: "4px 16px", fontSize: 26 }}>{badge}</span>}
      </div>
      <div style={{ padding: "30px 34px", fontSize: 30, color: "#333", lineHeight: 1.35 }}>{children}</div>
    </div>
  );
}

export default function S1() {
  return (
    <div className="still" data-testid="still-s1" style={{ width: 1080, height: 1920, background: "#E9E7E4" }}>
      <StatusBar time="6:02" />
      <div style={{ padding: "40px 72px 0", fontFamily: font }}>
        <div style={{ fontSize: 34, color: "#777", fontWeight: 500 }}>Tuesday, 6:02 PM</div>
        <div style={{ fontSize: 60, fontWeight: 700, color: "#222", letterSpacing: "-0.02em", marginTop: 4 }}>7 apps. 0 bookings.</div>
      </div>

      <App name="GlowBook" color="#2F6FEB" badge="3" top={330} left={60} rot={-3}>
        <b>Hydrating Facial</b> — next available <span style={{ color: "#E5484D", fontWeight: 600 }}>Thursday 11:40 AM</span>
        <div style={{ marginTop: 14, height: 62, borderRadius: 14, background: "#EEF3FF", display: "flex", alignItems: "center", padding: "0 20px", color: "#2F6FEB", fontWeight: 600 }}>Join waitlist</div>
      </App>

      <App name="SpaLine" color="#F59E0B" top={640} left={240} rot={2.5}>
        Session expired. <span style={{ color: "#999" }}>Please log in again to continue booking.</span>
        <div style={{ marginTop: 14, display: "flex", gap: 14 }}>
          <span style={{ flex: 1, height: 58, borderRadius: 12, background: "#FDEFD5" }} />
          <span style={{ width: 200, height: 58, borderRadius: 12, background: "#F59E0B" }} />
        </div>
      </App>

      <App name="Messages" color="#34C759" badge="2" top={920} left={40} rot={-1.5} w={720}>
        <div style={{ background: "#F1F1F1", borderRadius: 26, padding: "16px 24px", display: "inline-block", maxWidth: "85%" }}>Do you have anything for brows after 6 tonight?</div>
        <div style={{ marginTop: 10, color: "#999", fontSize: 26 }}>Delivered · 47 min ago</div>
      </App>

      <App name="Calendar" color="#E5484D" badge="!" top={1190} left={280} rot={3}>
        <span style={{ color: "#E5484D", fontWeight: 700 }}>Conflict:</span> Facial 6:00–7:00 overlaps Brow appt 6:30
      </App>

      <App name="Mail" color="#5B5BD6" badge="12" top={1440} left={90} rot={-2}>
        <b>We couldn’t hold your slot</b>
        <div style={{ color: "#888" }}>Your 6:30 PM request has expired. Rebook to…</div>
      </App>

      <div style={{ position: "absolute", left: 0, right: 0, bottom: 90, textAlign: "center", fontFamily: font, fontSize: 30, color: "#8a8a8a" }}>
        Battery 14% · 3 tabs · 2 missed calls
      </div>
      <HomeBar />
    </div>
  );
}
